import { bootstrapMe } from '~/nasa_ui/bootstrap_app';
import pkg from '../package.json';
import App from './App.vue';
import { COSMIC_APPLICATION, COSMIC_APPLICATION_CONFIGURATION, COSMIC_ENVIRONMENT, COSMIC_SYSTEM } from './application.config';
import router from './router';
// Start Logistics... cLog?
bootstrapMe({
    App,
    applicationVersion: pkg.version,
    cosmicApplication: COSMIC_APPLICATION,
    cosmicApplicationConfiguration: COSMIC_APPLICATION_CONFIGURATION,
    cosmicEnvironment: COSMIC_ENVIRONMENT,
    cosmicSystem: COSMIC_SYSTEM,
    router
});
